import filterPhoneNumberAnonymize from 'common/filters/filterPhoneNumberAnonymize'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

export type ReviewAuthorInfo = {
  label: string
  isPrivate: boolean
  patientTitle?: string
  patientProfileId?: string
}

/**
 * Подпись автора и можно ли открыть его профиль.
 *
 * Скрытый пользователь с профилем остаётся «Скрытый» без id:
 * клик по автору не должен открывать модалку.
 * Без профиля это гость — тоже без модалки.
 */
export default function getAuthorInfo(rate: Rate): ReviewAuthorInfo {
  const patientProfileId = rate.patient_profile_id != null
    ? String(rate.patient_profile_id)
    : ''

  if (patientProfileId && !rate.private_user) {
    const phone = rate.patient_profile?.phone
      ? filterPhoneNumberAnonymize(rate.patient_profile.phone)
      : ''

    return {
      label: `${tStatic('Пациент')} ${phone}`.trim(),
      isPrivate: false,
      patientTitle: phone,
      patientProfileId,
    }
  }

  if (patientProfileId && rate.private_user) {
    return {
      label: tStatic('Скрытый'),
      isPrivate: true,
    }
  }

  return {
    label: tStatic('Гость'),
    isPrivate: false,
  }
}
